import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { getAnalytics } from './analytics';

/**
 * Side-effect-only component that fires a `page` event whenever the route
 * changes. Mount once near the root of the authenticated shell — keeping
 * it inside React Router context guarantees `useLocation` is wired up.
 *
 * We intentionally fire on *every* path change (not just full reloads)
 * because most products care about per-screen funnel metrics; if you only
 * want hard navigations, swap `useLocation` for a `popstate` listener.
 */
export function AnalyticsRouteObserver() {
  const location = useLocation();

  useEffect(() => {
    getAnalytics().page(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
